import storage from 'local-storage-fallback'
import App from 'modules/App'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { installChunkLoadReload } from 'utils/reloadOnChunkLoadError'
// JS import (not CSS @import): css-loader @import only uses the `style` export
// and hits dist, which ModuleScopePlugin blocks via the docker kit symlink.
// Webpack `development` → empty stub; prod `default` → dist/gu-ui-kit.css.
import 'gu-ui-kit/gu-ui-kit.css'
import 'global.scss'
import 'unlayered.scss'

if (!('localStorage' in window)) {
  global.localStorage = storage
}

console.logXHR = console.error

if (process.env.NODE_ENV === 'production') {
  installChunkLoadReload()
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/frontend/react-app/sw.js', {
          scope: '/',
          updateViaCache: 'none',
        })
        .then((registration) => {
          const checkUpdate = () => {
            registration.update()
          }
          document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') {
              checkUpdate()
            }
          })
          window.setInterval(checkUpdate, 4 * 60 * 60 * 1000)
        })
        .catch(() => {})
    })
  }
}

const root = createRoot(document.getElementById('app-root'))
root.render(<App />)
